const seaCloudRequirements = ['siteismappedtoseacloud'];
const calRequirements = ['sitehastemperatureprofile', 'sitelatlon', 'siteismappedtoseacloud'];
const scenarioRequirements = [
  'siteismappedtoseacloud',
  'sitehastemperatureprofile',
  'sitelatlon',
  'sitecalibrationsettings',
  'sitecalibrationfeedprogram',
  'sitecalibrationfeedprogram',
];

export const hasSeaCloudAccess = (features: { [code: string]: boolean }) => seaCloudRequirements.every((req) => features[req]);

export const hasCalibrationAccess = (features: { [code: string]: boolean }) => calRequirements.every((req) => features[req]);

export const hasScenarioAccess = (features: { [code: string]: boolean }) => scenarioRequirements.every((req) => features[req]);
